import getAccountProperties from './getAccountProperties'

const isValidUserObj = (userObj: object | undefined) =>
  userObj && 'id' in userObj && 'email' in userObj

export default function isLoggedIn() {
  return isValidUserObj(getAccountProperties()) ?? false
}
